import React, { useEffect, useRef, useState } from "react"
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  ResourcesDirective,
  ResourceDirective,
  TimelineViews,
} from "@syncfusion/ej2-react-schedule"
import { createElement } from "@syncfusion/ej2-base"
import { Internationalization, isNullOrUndefined } from "@syncfusion/ej2-base"
import {
  DropDownList,
  MultiSelect,
  CheckBoxSelection,
} from "@syncfusion/ej2-dropdowns"
import {
  DropDownListComponent,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns"
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs"
import { ButtonComponent } from "@syncfusion/ej2-react-buttons"
import {
  DatePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars"

import { Header } from "../../UI"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { useQuery } from "react-query"
import { capitalize, upperCase } from "lodash"
import {
  assignEmployee,
  getBookingByDates,
  reminderMail,
  reminderMessage,
} from "../../../axios/api/apiModule"
import { openToastify } from "../../store/actions/toastifyAction"
import {
  REDUX_STORE_DEFAULTS,
  REDUX_TOASTIFY_DEFAULTS,
} from "../../store/config"
import "./styles.css" // Import the CSS file
import { bookingAction } from "../../store/actions/bookingAction"
import { extend } from "@syncfusion/ej2-base"
import Loader from "../../../components/asserts/Spin.gif"
import CreateBooking from "../../UI/createBooking/CreateBooking"
import useSSEListener from "../../../utils/useSSE"
import {
  getAgendaBookingHTML,
  getDaysBookingHTML,
} from "./calendarEventComponent/EventRender"
import ViewBooking from "../../UI/ViewBooking"

// eslint-disable-next-line react/destructuring-assignment
const PropertyPane = (props) => <div className="mt-5">{props.children}</div>

const ManagerScheduler = () => {
  const scheduleObj = useRef(null)
  const calendarView = localStorage.getItem("calendarView")
  const [currentView, setCurrentView] = useState(
    window.innerWidth < 768 ? "Day" : calendarView,
  )
  let { sseConnection } = useSelector((state) => state.userReducer)
  let { employeeListData } = useSelector((state) => state.employeeReducer)
  let { allBookingData, isBookingUpdated } = useSelector(
    (state) => state.bookingReducer,
  )
  const dispatch = useDispatch()
  // Refs for MultiSelect components
  const empAssignObj = useRef(null)
  const [isEventData, setIsEventData] = useState({})
  const [newAssignEmp, setNewAssignEmp] = useState({})
  const [isAssEmpLoading, setIsAssEmpLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isForm, setIsForm] = useState(false)
  const [isData, setIsData] = useState()
  const [isEditData, setIsEditData] = useState(false)
  const [isEmployee, setIsEmployee] = useState(false)
  const [isBookingStatusSlide, setIsBookingStatusSlide] = useState(false)

  //change in calender or booking
  const change = (args) => {
    scheduleObj.selectedDate = args.value
    scheduleObj.dataBind()
  }

  const onDragStart = (arg) => {
    // eslint-disable-next-line no-param-reassign
    arg.navigation.enable = true
  }

  useEffect(() => {
    localStorage.setItem("calendarView", currentView)
  }, [currentView])

  const [calendarData, setCalendarData] = useState([])

  //formatBookingData
  const formatBookingData = (data) => {
    return data.map((allBookingData) => {
      const {
        _id,
        firstName,
        lastName,
        phoneNumber,
        email,
        bookingStatus,
        locationType,
        bookingDate,
        bookingSlot,
        booking,
        isWaterAvailable,
        isElectricityAvailable,
        totalAmount,
        empAssigned,
        createdAt,
        location,
        shortBookingId,
        note,
      } = allBookingData

      const description = `
Customer: ${firstName} ${lastName}
Phone: ${phoneNumber}
Email: ${email}
Location: ${locationType === "shop" ? "Shop" : location || "N/A"}

Services Details:-
${booking
  .map((b) => {
    const serviceInfo = `- ${b.service.serviceOption} - ${b.service.categoryName} / ${b.service.packageName} - $${b.servicePrice}`

    const addonsInfo =
      b.addonService && b.addonService.length > 0
        ? b.addonService
            .map((a) => `${a.addonServiceName} - $${a.addonSalePrice}`)
            .join(",\n")
        : ""

    const imagesInfo =
      b.images && b.images.length > 0
        ? b.images
            .map((image, index) => `Image ${index + 1}: ${image}`)
            .join(",\n")
        : ""

    return `${serviceInfo}${
      addonsInfo ? `; \nAddon Services:- \n${addonsInfo}` : ""
    }`
  })
  .join(";\n\n")}

- Water Available: ${isWaterAvailable ? "Yes" : "No"}
- Electricity Available: ${isElectricityAvailable ? "Yes" : "No"}

Total Amount: $${totalAmount}

Note: ${note || "N/A"}
`.trim()

      // ✅ Start & End time (using bookingDate + bookingSlot)
      const startTime = moment(
        `${bookingDate} ${bookingSlot}`,
        "YYYY-MM-DD HH:mm",
      )
      const endTime = moment(startTime).add(1, "hours")

      const newCreated = moment(createdAt)

      // Extract all image URLs
      const images = booking.flatMap((b) => b.images || [])

      return {
        Id: _id,
        Subject: `${moment(startTime).format("HH:mm A")} ${firstName} #${shortBookingId}`,
        Description: description,
        Location: locationType,
        StartTime: startTime.toISOString(),
        EndTime: endTime.toISOString(),
        Status: bookingStatus,
        empAssigned,
        CreatedAt: newCreated.toISOString(),
        Images: images,
        allBookingData,
      }
    })
  }

  //fetch booking data
  const formatDate = (date) => {
    return date.toISOString().split("T")[0]
  }
  const getDateRangeFromScheduler = (selectedDate) => {
    const start = new Date(selectedDate)
    start.setDate(start.getDate() - 2)

    const end = new Date(selectedDate)
    end.setDate(end.getDate() + 10)

    return {
      startDate: formatDate(start),
      endDate: formatDate(end),
    }
  }
  const fetchAllBookingsByDateRange = async (
    startDate,
    endDate,
    locationType,
    pageSize = 20,
  ) => {
    let page = 1
    let allBookings = []
    let hasMore = true

    while (hasMore) {
      const payload = {
        page,
        pageSize,
        startDate,
        endDate,
        locationType,
      }

      const res = await getBookingByDates(payload)

      if (!res?.success) break

      const orders = res.data?.orders || []
      const pagination = res.data?.pagination

      allBookings = [...allBookings, ...orders]

      hasMore = pagination?.hasNextPage
      page += 1
    }

    return allBookings
  }
  useEffect(() => {
    const handleFetchData = async (params) => {
      setIsLoading(true)
      const { startDate, endDate } = getDateRangeFromScheduler(new Date())
      const allData = await fetchAllBookingsByDateRange(
        startDate,
        endDate,
        "shop",
      )
      setCalendarData(formatBookingData(allData ?? []))
      setIsLoading(false)
    }
    handleFetchData()
  }, [])

  useSSEListener((message) => {
    if (message.type === "showBookingAdmin:update") {
      const info = message.payload
      const newData = formatBookingData([info])
      setCalendarData((prev) => [...newData, ...prev])
      // if (info.locationType === "shop") {
      //   setCalendarData((prev) => [...newData, ...prev])
      // }
    }

    if (message.type === "showBookingStatusAdmin:update") {
      const info = message.payload
      const bookingId = info._id

      setCalendarData((prev) => {
        const index = prev.findIndex(
          (b) => b?.allBookingData?._id === bookingId || b.Id === bookingId,
        )

        // ❌ Do nothing if booking not found
        if (index === -1) return prev

        const updated = [...prev]

        updated[index] = {
          ...updated[index],
          allBookingData: {
            ...updated[index].allBookingData,
            bookingStatus: info.bookingStatus,
          },
          Status: info.bookingStatus, // if calendar uses Status field
        }

        return updated
      })
    }
  })
  // END - fetch booking Data

  // useEffect(() => {
  //   console.log(isEventData, "isEventData")
  // }, [isEventData])

  //update booking
  const update = () => {
    dispatch(
      bookingAction(
        REDUX_STORE_DEFAULTS.UPDATE_BOOKING_DATA(),
        !isBookingUpdated,
      ),
    )
  }

  // Calendar onPopupOpen
  const onPopupOpen = (args) => {
    console.log("onPopupOpen", args.data)
    const data = args.data
    setIsEventData(data)
    if (args.type === "Editor" || args.type === "QuickInfo") {
      args.cancel = true
      console.log(args.data, "args.data")
    }
  }
  useEffect(() => {
    const handler = (e) => {
      const card = e.target.closest(".agenda-booking-card")
      if (!card) return

      const bookingId = card.dataset.bookingId

      const booking = calendarData.find((b) => b.Id === bookingId)
      console.log(bookingId, booking)

      if (booking) {
        onPopupOpen({ data: booking, type: "" })
      }
    }
    document.addEventListener("click", handler)
    return () => document.removeEventListener("click", handler)
  }, [calendarData])

  // handle Create Model - Start
  const onClickAdd = () => {
    setIsForm(true)
  }
  const closeEdit = () => {
    if (isForm) {
      setIsData()
      setIsForm(false)
    }
    setIsEditData(false)
  }
  // handle Create Model - End

  //Editor Template
  const getStatusColor = (status, location, isAppbooking) => {
    const statusColors = {
      pending: "#cc9d51", // yellow
      processing: "#ffb878", // yellow
      confirmed:
        location === "shop"
          ? isAppbooking
            ? "#0B8043"
            : "#10B981"
          : isAppbooking
            ? "#3F51B5"
            : "#5484ed", // green for shop, white otherwise
      completed: "#ababab", // gray
      cancelled: "#dc2127", // red
    }
    return statusColors[status] || "#000000"
  }
  const onEventRendered = (args) => {
    const event = args.data
    const booking = event.allBookingData

    // Apply background color from event data
    // if (event.Color) {
    //   args.element.style.backgroundColor = event.Color
    //   args.element.style.borderRadius = "8px"
    //   args.element.style.color = "#fff"
    //   args.element.style.padding = "4px"
    // }

    args.element.style.backgroundColor = "transparent"
    args.element.style.height = "auto"
    // Replace default content with custom HTML
    if (currentView === "Day") {
      args.element.innerHTML = getDaysBookingHTML(booking, getStatusColor)
    } else {
      args.element.innerHTML = getAgendaBookingHTML(booking, getStatusColor)
    }
  }
  // Event triggered before navigation (optional)
  const onNavigating = (args) => {
    setCurrentView(args.currentView)
  }

  const onPopupClose = (args) => {
    console.log("onPopupClose", args)
    setIsBookingStatusSlide(false)
    setIsEmployee(false)
  }

  //handleResize Calendar
  const handleResize = () => {
    if (window.innerWidth < 680) {
      setCurrentView("Day")
    } else {
      setCurrentView("Agenda")
    }
  }
  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  // const [isAutoScrollEnabled, setIsAutoScrollEnabled] = useState(false)
  // useEffect(() => {
  //   // ❌ Do nothing unless conditions are met
  //   if (!isAutoScrollEnabled || currentView !== "Agenda") {
  //     return
  //   }

  //   const getScrollableContainer = () =>
  //     document.querySelector(".e-content-wrap") ||
  //     document.querySelector(".e-schedule-content")

  //   let container = null
  //   let interval = null
  //   let direction = 1
  //   let isPaused = false

  //   const SCROLL_STEP = 0.7
  //   const SCROLL_INTERVAL = 30
  //   const PAUSE_DURATION = 5000

  //   const startScroll = () => {
  //     container = getScrollableContainer()
  //     if (!container) return

  //     // 🔑 force scrollable
  //     container.style.overflowY = "auto"

  //     // ❌ skip if no overflow
  //     if (container.scrollHeight <= container.clientHeight + 2) {
  //       return
  //     }

  //     interval = setInterval(() => {
  //       if (isPaused) return

  //       const atBottom =
  //         container.scrollTop + container.clientHeight >=
  //         container.scrollHeight - 2

  //       const atTop = container.scrollTop <= 0

  //       if (direction === 1 && atBottom) {
  //         isPaused = true
  //         setTimeout(() => {
  //           direction = -1
  //           isPaused = false
  //         }, PAUSE_DURATION)
  //         return
  //       }

  //       if (direction === -1 && atTop) {
  //         isPaused = true
  //         setTimeout(() => {
  //           direction = 1
  //           isPaused = false
  //         }, PAUSE_DURATION)
  //         return
  //       }

  //       container.scrollTop += SCROLL_STEP * direction
  //     }, SCROLL_INTERVAL)
  //   }

  //   // Delay until scheduler renders
  //   const startTimeout = setTimeout(startScroll, 1200)

  //   // 🔄 Re-evaluate on resize / zoom
  //   const handleResize = () => {
  //     if (interval) clearInterval(interval)
  //     startScroll()
  //   }

  //   window.addEventListener("resize", handleResize)

  //   return () => {
  //     clearTimeout(startTimeout)
  //     if (interval) clearInterval(interval)
  //     window.removeEventListener("resize", handleResize)
  //   }
  // }, [calendarData, currentView, isAutoScrollEnabled])

  const [scheduleHeight, setScheduleHeight] = useState("100vh")
  useEffect(() => {
    const updateHeight = () => {
      const headerOffset = 200 // adjust if you have navbar / filters
      setScheduleHeight(`${window.innerHeight - headerOffset}px`)
    }

    updateHeight()
    window.addEventListener("resize", updateHeight)

    return () => window.removeEventListener("resize", updateHeight)
  }, [])

  return (
    <div className="m-2 md:m- 10 mt- 24 p- 2 md:p- 10 bg-white rounded-3xl flex-1">
      <div className="flex w-full justify-between">
        <Header title="Managed Calendar" />
        <div>
          {sseConnection ? (
            <ul className="text-red-800 font-bold list-disc">
              <li>Live Update</li>
            </ul>
          ) : (
            <ul className="text-yellow-500 font-bold list-disc">
              <li>Offline</li>
            </ul>
          )}
        </div>
      </div>
      <ButtonComponent id="add" title="Add" onClick={onClickAdd}>
        Create Booking
      </ButtonComponent>
      {/* <ButtonComponent
        id="start"
        title="Start"
        onClick={() => {
          setIsAutoScrollEnabled(!isAutoScrollEnabled)
        }}
      >
        {isAutoScrollEnabled ? "Stop Scroll" : "Enable Auto Scroll"}
      </ButtonComponent> */}
      <ScheduleComponent
        width="100%"
        height={scheduleHeight}
        rowAutoHeight={true}
        // selectedDate={new Date()}
        ref={scheduleObj}
        currentView={currentView}
        eventSettings={{ dataSource: calendarData }}
        showQuickInfo={true}
        eventRendered={onEventRendered}
        navigating={onNavigating}
        popupOpen={onPopupOpen}
        popupClose={onPopupClose}
        // timezone={"UTC"}
        agendaDaysCount={1}
      >
        <ViewsDirective>
          {["Day", "Week", "Month", "Agenda"].map((item) => (
            <ViewDirective key={item} option={item} />
          ))}
        </ViewsDirective>
        <Inject
          services={[Day, Week, WorkWeek, Month, Agenda, Resize, TimelineViews]}
        />
      </ScheduleComponent>

      {/* booking form */}
      {isForm ? (
        <>
          <CreateBooking
            data={isData}
            onClick={closeEdit}
            isEdit={isEditData}
          />
        </>
      ) : (
        <></>
      )}

      {isLoading ? (
        <div className="flex justify-center items-center absolute inset-0">
          <div>
            <img src={Loader} alt="" className="w-20" />
          </div>
        </div>
      ) : (
        <></>
      )}

      {isEventData?.allBookingData && (
        <ViewBooking
          data={isEventData.allBookingData}
          onClick={() => setIsEventData()}
          onEdit={() => {
            setIsForm(true)
            setIsEditData(true)
            setIsData(isEventData.allBookingData)
            setIsEventData({})
          }}
        />
      )}

      {/* <PropertyPane>
        <table style={{ width: "100%", background: "white" }}>
          <tbody>
            <tr style={{ height: "50px" }}>
              <td style={{ width: "100%" }}>
                <DatePickerComponent
                  value={new Date()}
                  showClearButton={false}
                  placeholder="Current Date"
                  floatLabelType="Always"
                  change={change}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </PropertyPane> */}
    </div>
  )
}

export default ManagerScheduler

const InfoBox = ({ label, value }) => (
  <div className="rounded-lg bg-gray-50 p-3">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="font-medium">{value}</div>
  </div>
)

const PriceRow = ({ label, value }) => (
  <div className="flex justify-between text-sm">
    <span>{label}</span>
    <span>${value}</span>
  </div>
)
